import React, { useEffect, useState } from "react"
import { useHistory } from "react-router"

import store from "redux/store"
import { SSOLogin } from "redux/ducks/user"
import { setChartSession } from "../../../atoms/chart/logic/chartSession"

export const SSO: React.FC = () => {
  const [isError, setError] = useState<boolean>(null)
  const history = useHistory()
  const success = async () => {
    await setChartSession()
    history.push("top/summary")
  }
  const failed = () => {
    setError(true)
  }
  // 外部からのSSOの仕様決まり次第修正
  useEffect(() => {
    store.dispatch(SSOLogin()).then(success, failed)
  }, [])
  return <>{isError ? <div>認証エラー</div> : null}</>
}
